<app-header></app-header>
<div class="content_wrapper">
    <div class="panel-set">
        <div class="panel-pharse">

            <!--head section-->

            <div class="reg-head">
                <div class="phrase_edit_heading text-capitalize">
                    {{project}}
                </div>
            </div>

            <!--panel tab sec--->

            <div class="panel_data_phrase">
                <div class="ui-tabs-report">
                    <div class="container pt-4">
                        <ul class="nav nav-tabs" id="tab-next-prev" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3" aria-selected="false"><i class="fa fa-envelope"></i><span>Requested Keywords</span></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4" aria-selected="false"><i class="fa fa-file-text-o"></i><span>Project Keywords</span></a>
                            </li>
                        </ul>

                        <div class="tab-content key-add" id="tab-next-prev-content">
                            <!--Notifications tab-->

                            <div class="tab-pane fade show active" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">
                                <div class="add_user">
                                    <div class="add_form_sec">
                                        <form [formGroup]="form" (ngSubmit)="doAction()">
                                            <div class="form-group col-md-8">
                                                <label for="keyword">Keywords</label>
                                                <ng-select [items]="keywords" 
                                                           formControlName="keyword"
                                                           [multiple]="true"
                                                           notFoundText=""
                                                           [addTag]="true"
                                                           addTagText=""
                                                           [clearable]="false"
                                                           class="form-control">
                                                </ng-select>
                                                <span class="error_message" *ngIf="err.keyword">{{err.keyword}}</span>
                                            </div>

                                            <div class="form-group col-md-4">
                                                <button class="panel_save_btn">Save</button>
                                            </div>
                                        </form>

                                        <div class="not-sec">
                                            <div class="not-table table-responsive">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Keywords</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let keyword of user_keywords; let i=index;">
                                                            <td>{{keyword.keyword}}</td>
                                                            <td>{{keyword.status_name}}</td>
                                                            <td *ngIf="keyword.status != 1">--</td>
                                                            <td *ngIf="keyword.status == 1">
                                                                <a (click)="edit_keyword(keyword)"><span><img src="assets/images/edit.png"></span>Edit</a>&nbsp;
                                                                <a (click)="delete_keyword(keyword.id, 1)"><span><img src="assets/images/delete.png"></span>Delete</a>
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="!total_user_keywords"><td colspan="3">No Keywords Found</td></tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>


                                </div>

                            </div>


                            <!--Reports tab-->
                            <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">
                                <div class="add_user">
                                    <div class="add_form_sec">
                                        <!--<div class="not-sec">
                                            <span *ngFor="let key of project_keywords;" class="badge badge-primary">{{key.str_keyword}}</span>
                                        </div>-->
                                        <div class="not-sec">
                                            <div class="not-table table-responsive">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Keywords</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let keyword of user_keywords; let i=index;">
                                                            <td>{{keyword.keyword}}</td>
                                                            <td>{{keyword.status_name}}</td>
                                                            <td *ngIf="keyword.status != 2">Delete request send</td>
                                                            <td *ngIf="keyword.status == 2">
                                                                <a (click)="delete_keyword(keyword.id, 2)"><span><img src="assets/images/delete.png"></span>Delete</a>
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="!total_user_keywords"><td colspan="3">No Keywords Found</td></tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<!-- The Modal -->
<div class="form-popup" id="myForm" *ngIf="edit_form.value.id">
    <form [formGroup]="edit_form" (ngSubmit)="doEditAction()" class="form-container">
        <h6>Update</h6>

        <label for="email"><b>Keyword</b></label>
        <input type="text" formControlName="keyword">
        <span class="error_message" *ngIf="edit_err.keyword">{{edit_err.keyword}}</span>
        <button type="submit" class="btn">Update</button>
        <button type="button" class="btn cancel" (click)="closeForm()">Close</button>
    </form>
</div>


<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "rgb(199, 28, 109)" type = "square-loader" [fullScreen] = "true"></ngx-spinner>
<app-footer></app-footer>